import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { throwIfRequestError } from "../../hooks/request-error";

// Finance Orders tab — GET /api/userOrder/admin, the SAME endpoint and rows the
// pharmacist Orders screen already reads (`.scratch/finance-dashboard/IMPLEMENTATION.md`
// §5.5 directive: extend, don't duplicate). The finance-only fields
// (`financeTotalAmount`, `financeOutstanding`, `financeEvitalPrintUrl`) are additive —
// see classes/UserOrder/Functions.js (pillup-api) — everything else on a row is exactly
// what the pharmacist console already gets.
export default function useFinanceOrders({ page = 1, size = 20, statuses = [], enabled = true } = {}) {
    const params = {
        page,
        size,
        // Raw statuses from the selected status chips, comma-joined; omitted = every status.
        ...(statuses.length ? { status: statuses.join(",") } : {}),
    };

    return useQuery(
        ["finance-orders", params],
        async () => {
            const result = await request({ url: "userOrder/admin", method: "GET", params });
            throwIfRequestError(result);
            const body = result.data;
            if (!body?.success) throw body;

            const { count, rows } = body.data;
            return {
                orders: rows || [],
                pagination: { page, size, total: Number(count) || 0 },
            };
        },
        { keepPreviousData: true, retry: false, enabled }
    );
}
